import React, { useState, useMemo } from 'react';

import PropTypes from 'prop-types';
import {
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';

import Charts from '../Chart';

import * as S from './styles';

export default function GroupCharts({
  form,
  categories,
  heights,
  temperatures,
  volumes,
}) {
  const [height, setHeight] = useState(false);
  const [temperature, setTemperature] = useState(false);
  const [volume, setVolume] = useState(false);

  return (
    <S.Wrapper>
      <FormControl component="fieldset">
        <FormGroup row>
          <FormControlLabel
            control={
              <Checkbox
                checked={height}
                onChange={(e) => setHeight(e.target.checked)}
              />
            }
            label="Altura"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={temperature}
                onChange={(e) => setTemperature(e.target.checked)}
              />
            }
            label="Temperatura"
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={volume}
                onChange={(e) => setVolume(e.target.checked)}
              />
            }
            label="Volume"
          />
        </FormGroup>
      </FormControl>

      {height && (
        <Charts
          name={`Medições Altura ${form}`}
          data={heights}
          categories={categories}
        />
      )}

      {temperature && (
        <Charts
          name={`Medições Temperatura ${form}`}
          data={temperatures}
          categories={categories}
        />
      )}

      {volume && (
        <Charts
          name={`Medições Volume ${form}`}
          data={volumes}
          categories={categories}
        />
      )}
    </S.Wrapper>
  );
}

GroupCharts.propTypes = {
  heights: PropTypes.objectOf(PropTypes.any).isRequired,
  temperatures: PropTypes.objectOf(PropTypes.any).isRequired,
  volumes: PropTypes.objectOf(PropTypes.any).isRequired,
  form: PropTypes.string.isRequired,
};
